import Vue from 'vue'
import { setupPlugin, EToastPlacement } from '@twago/toast'

export default setupPlugin(Vue, EToastPlacement.TOP)
